import Course from "../page/course/Course";
import CourseConsumer from "../../../context/course/CourseConsumer";

export default function CourseHOC({ ...props }) {
  return (
    <CourseConsumer>
        {({ ...rest }) => {
            return <Course {...props} {...rest} />;
        }}
    </CourseConsumer>
  );
}
